import { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const TranslationsReloader = () => {
  const { i18n } = useTranslation();

  useLayoutEffect(() => {
    i18n.reloadResources();
  }, []);

  return null;
};
